import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTwitter, faInstagram } from "@fortawesome/free-brands-svg-icons";
import { faShoppingBag } from "@fortawesome/free-solid-svg-icons";
import { MDBContainer } from "mdb-react-ui-kit";
import tripleTLogo from "../../assets/images/TTTLogo.png";
import "../../assets/styles/Footer.css";

export default function Footer() {
  return (
    <MDBContainer className="footer-container" fluid>
      <div className="footer-logo">
        <img src={tripleTLogo} />
      </div>
      <div className="d-flex justify-content-center footer-social-icons">
        <div>
          <a target="_blank" href="https://mobile.twitter.com/tirothetyrant">
            <FontAwesomeIcon icon={faTwitter} />
          </a>
        </div>
        <div>
          <a
            target="_blank"
            href="https://www.instagram.com/tirothetyrant/?hl=en"
          >
            <FontAwesomeIcon icon={faInstagram} />
          </a>
        </div>
        <div>
          <a target="_blank" href="https://tirothetyrant.myshopify.com/">
            <FontAwesomeIcon icon={faShoppingBag} />
          </a>
        </div>
      </div>
      <div>COPYRIGHT {new Date().getFullYear()}. TRIPLE CROSS RECORDS</div>
    </MDBContainer>
  );
}
